import { R as REQUIRED_EVENT_FIELDS } from "./analytics-8dc6db1f.js";
import { i as isLoggerValid } from "./videoData-e54b4336.js";
import { analyticsFreedom } from "./browser/plugins/freedom/index.es.js";
import { analyticsTealium } from "./browser/plugins/tealium/index.es.js";
const getLeadUUID = (analytics) => {
  const { userId, anonymousId } = analytics.user();
  return userId || anonymousId;
};
const checkRequiredFields = (payload) => {
  Object.values(REQUIRED_EVENT_FIELDS).forEach((field) => {
    if (!payload.properties[field]) {
      console.error(
        "Missing required field on analytics call: ",
        field,
        payload.properties
      );
    }
  });
};
const analyticsDebug = ({ options = {} }) => {
  const logger = isLoggerValid(options.logger) ? options.logger : console;
  return {
    identify: ({ payload }) => {
      logger == null ? void 0 : logger.info("ANALYTICS :: debug :: identify", payload);
    },
    /* Everything else below this is optional depending on your plugin requirements */
    initialize: ({ config }) => {
      logger == null ? void 0 : logger.info("ANALYTICS :: debug :: initialize", config);
    },
    loaded: () => true,
    /* All plugins require a name */
    name: "debug-plugin",
    page: ({ payload }) => {
      var _a;
      checkRequiredFields(payload);
      logger == null ? void 0 : logger.info(
        `ANALYTICS :: debug :: page - ${(_a = payload == null ? void 0 : payload.properties) == null ? void 0 : _a.page_name} - Page Loaded`,
        payload
      );
    },
    track: ({ payload }) => {
      var _a;
      checkRequiredFields(payload);
      logger == null ? void 0 : logger.info(
        `ANALYTICS :: debug :: track - ${(_a = payload == null ? void 0 : payload.properties) == null ? void 0 : _a.page_name} - ${payload == null ? void 0 : payload.event}`,
        payload
      );
    }
  };
};
const analyticsJest = (callback) => {
  if (!callback) {
    return {
      name: "unit-test-analytics-plugin"
    };
  }
  return {
    identify: () => {
      callback("identify");
    },
    initialize: () => {
      callback("initialize");
    },
    loaded: () => true,
    name: "unit-test-analytics-plugin",
    page: () => {
      callback("page");
    },
    track: () => {
      callback("track");
    }
  };
};
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  analyticsDebug,
  analyticsFreedom,
  analyticsJest,
  analyticsTealium
}, Symbol.toStringTag, { value: "Module" }));
export {
  getLeadUUID as g,
  index as i
};
